import * as THREE from 'three';

import {Model} from '../lib/Model';

export class Intro extends Model {
    startMaterial = new THREE.ShaderMaterial({
        vertexShader: `
                void main() {
                    gl_Position = vec4(position,1.0);
                }
            `,
        fragmentShader: `
                void main() {
                    gl_FragColor = vec4(1.0,1.0,1.0,1.0);
                }
            `,
    });

    constructor(viewer, introImagePath, model, load) {
        super('intro', viewer, model);

        this.model = new THREE.Mesh(new THREE.PlaneGeometry(2, 2, 1, 1), this.startMaterial);

        const textureLoader = new THREE.TextureLoader();
        textureLoader.load(introImagePath, (texture) => {
            this.model.material = new THREE.ShaderMaterial({
                transparent: true,
                uniforms: {
                    uTexture: new THREE.Uniform(texture),
                    uAlpha: {
                        value: 1,
                    },
                },
                vertexShader: `
                    varying vec2 vUv;

                    void main() {
                        vUv = uv;
                        gl_Position = vec4(position,1.0);
                    }
                `,
                fragmentShader: `
                    uniform float uAlpha;
                    uniform sampler2D uTexture;

                    varying vec2 vUv;

                    void main() {
                        gl_FragColor = vec4(texture2D(uTexture, vUv).rgb, uAlpha);
                    }
                `,
            });

            load();
        });
    }

    static create(viewer, introImagePath, load) {
        return new Intro(viewer, introImagePath, null, load);
    }

    dispose() {
        this.startMaterial.dispose();
        super.dispose();
    }

    // eslint-disable-next-line class-methods-use-this
    animate() {
    }
}
